<template>
  <div class="container py-16 print:py-0">
    <h3>Test Results</h3>
    <div class="flex flex-wrap -mx-5">
      <div class="w-full print:w-1/2 sm:w-1/2 px-5">
        <p>Full Name: {{ foundResults.fullName }}</p>
        <p>Contact ID: {{ foundResults.username }}</p>
        <p>Start Date: {{ foundResults.startDateTime | formatShortDateTime }}</p>
        <p v-if="foundResults.completed">
          Finish Date: {{ foundResults.finishDateTime | formatShortDateTime }}
        </p>
        <p>
          Status: {{ foundResults.completed ? 'Completed' : 'In Progress' }}
        </p>
      </div>
      <div class="w-full print:w-1/2 sm:w-1/2 px-5">
        <p>Total Questions: {{ foundResults.totalQuestions }}</p>
        <p>Test Type: {{ foundResults.testType }}</p>
        <div v-if="foundResults.completed">
          <p>Passed: {{ foundResults.passed }}</p>
          <p>Final Percentage: {{ foundResults.percentageGrade | formatDecimalAsPercentage }}</p>
        </div>
      </div>
    </div>

    <hr>

    <div>
      <div v-for="question in questions" :key="question.orderNumber" class="mb-12">
        <div class="mb-2">
          <p class="font-bold">
            Question ({{ question.orderNumber }} of {{ totalQuestions }}):
          </p>
          <p>{{ question.content }}</p>
        </div>

        <div class="mb-2">
          <p class="font-bold">
            Answered Page Number:
          </p>
          <div v-if="question.selectedPageNumber" class="flex">
              <div class="w-10 text-center pt-1">
                      <d-icon v-if="question.selectedPageNumberCorrect" icon="check" class="text-success" />
                      <d-icon v-else icon="times" class="text-error" />
              </div>
              <div class="flex-grow">
                  {{ question.selectedPageNumber }} ({{ question.correctPageNumber }} Correct Answer)
              </div>
          </div>
          <div v-else>
            No answer provided
          </div>
        </div>

        <p class="font-bold">
          Answers:
        </p>

        <div v-for="(answer, index) in question.answers" :key="index" class="flex items-center mb-1">
          <div class="w-10 text-center pt-1">
            <div v-if="answer.isSelectedAnswer">
              <d-icon v-if="answer.isCorrect" icon="check" class="text-success" />
              <d-icon v-else icon="times" class="text-error" />
            </div>
          </div>
          <div class="flex-grow">
            {{ answer.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    parent: true,
    filters: {
      formatDecimalAsPercentage(value) {
        const number = value * 100;
        const numberString = number.toString();
        const percentage = `${numberString}%`;
        return percentage;
      },
    },
    props: ['results'],
    data() {
      return {
        foundResults: this.results,
        totalQuestions: this.results.questions.length,
      };
    },

    computed: {
      questions() {
        const cloned = JSON.parse(JSON.stringify(this.results.questions));
        return cloned.sort((a, b) => a.orderNumber - b.orderNumber);
      },
    },
  };
</script>
